import { contexts } from 'constants/context';

const contextsThatHideHeader = [contexts.login, contexts.authentication];
const contextsThatHideSidebar = [contexts.login, contexts.authentication];
const contextsThatDontRequireStaticData = [
  contexts.login,
  contexts.authentication,
  contexts.companies,
  contexts.addCompany,
  contexts.profile,
  contexts.closedCircles,
  contexts.notFound,
];
const contextsThatDontRequireCompanyProfileData = [
  contexts.login,
  contexts.authentication,
  contexts.doctors,
  contexts.addCompany,
  contexts.closedCircles,
  contexts.notFound,
];

const hideElements = {
  contextsThatHideHeader,
  contextsThatHideSidebar,
  contextsThatDontRequireStaticData,
  contextsThatDontRequireCompanyProfileData,
};

export default hideElements;
